import { TAXRATE } from '../actionTypes';

const initialState = {
  content: [],
  taxes: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TAXRATE.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case TAXRATE.SUCCESS_TAXES:
      return {
        ...state,
        taxes: action.payload.content,
      };
    default:
      return state;
  }
};
